import { Action, ActionType } from "@redux/actionTypes/formulationDevActionTypes";
import { Reducer } from "redux";
import { Iheaders } from "./analyticalPBFReducer";

export interface IFormulationDevState {
  formulationDetailsByPID: IFormulationDetailsByPID[];
}

export interface IFormulationDetailsByPID {
  projectDuration: string;
  projectDetail: Partial<IProjectDeatils>;
  strength: string;
  strengthUnit: string;
  countries: string;
  dosage: string;
  apiRateDetails: Imolecules[];
  phasewiseDevelopmentBudget: IPhasewiseDevelopmentBudget;
  formulationDevelopmentSummary: IPhasewiseDevelopmentBudget;
}

interface IProjectDeatils {
  projectId: string;
  projectName: string;
  refDrugBrand: string;
  refDrugBrandOwner: string;
  formulationDevelopment: IFormulationDevelopment;
}
export interface IFormulationDevelopment {
  projectId?: number;
  formulationId?: string;
  // inHouseApidevelopment: string;
  initiatedDate: string;
  divisionId: number;
  rdProjectManager: number;
  complexityId: number;
  isDraft?: boolean;
  currencyId: number;
  apiRateDetails: Imolecules[];
}
export interface Imolecules {
  molecule: string;
  rate: string;
}

export interface IPhasewiseDevelopmentBudget {
  headers: Iheaders[];
  data: Record<string, any>[];
  total?: Record<string, any>;
}

const initialState = {
  formulationDetailsByPID: [],
};

export const formulationDevReducer: Reducer<IFormulationDevState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.FORMULATION_DETAILS_BY_PID:
      return {
        ...state,
        formulationDetailsByPID: action.payload,
      };
    case ActionType.RESET_REDUX_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};
